import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Img from "@insite/mobius/Img";
import { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {
    extendedStyles?: SearchContentStyles;
}

export interface SearchContentStyles {
    wrapper?: InjectableCss;
    leftSection?: InjectableCss;
    rightSection?: InjectableCss;
}

export const searchContentStyles: SearchContentStyles = {
    wrapper: {
        css: css`
            display: flex;
            flex-direction: row;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            flex-direction: column;
                            align-items: center;
                        `,
                    ],
                    "max",
                )}
            justify-content: space-between;
            padding: 30px 0;
            align-items: center;
        `,
    },
    leftSection: {
        css: css`
            width: 65%;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            width: 100%;
                        `,
                    ],
                    "max",
                )}
        `,
    },
    rightSection: {
        css: css`
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 22%;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 100%;
                        padding-top: 20px;
                    `,
                    css`
                        width: 50%;
                        padding-top: 20px;
                    `,
                ])}
        `,
    },
};

type Props = OwnProps;
const GAIAFooterBottomStrip: FC<Props> = ({ extendedStyles }) => {
    const [styles] = React.useState(() => mergeToNew(searchContentStyles, extendedStyles));
    const imgSrc = "/UserFiles/Images/footer-logo.png";
    return (
        <StyledWrapper {...styles.wrapper}>
            <StyledWrapper {...styles.leftSection}>
                <Typography size={13} color="common.background">
                    *This statement has not been evaluated by the Food and Drug Administration. This product is not
                    intended to diagnose, treat, cure, or prevent any disease.
                </Typography>
            </StyledWrapper>
            <StyledWrapper {...styles.rightSection}>
                <StyledWrapper
                    css={css`
                        width: 70%;
                    `}
                >
                    <Typography size={13} color="common.background">
                        We believe in using business as a force for good.
                    </Typography>
                </StyledWrapper>
                <StyledWrapper
                    css={css`
                        width: 25%;
                        border-left: 1px solid #707070;
                        text-align: right;
                    `}
                >
                    <Img src={imgSrc} altText="Message Icon" />
                </StyledWrapper>
            </StyledWrapper>
        </StyledWrapper>
    );
};

const gAIAFooterBottomStrip: WidgetModule = {
    component: GAIAFooterBottomStrip,
    definition: {
        group: "Basic",
        icon: "LinkList",
        displayName: "GAIA Footer Bottom Strip",
        fieldDefinitions: [],
    },
};

export default gAIAFooterBottomStrip;
